import React from "react";
import { ExtractionError } from "../../../model/ExtractionError";

export function ErrorMessageCell({ value }: { value: ExtractionError | undefined }) {
  if (!value?.detail?.length) {
    return <span style={{ color: "#aaa" }}>No error</span>;
  }

  return <span>{value.detail.join(", ")}</span>;
}
